/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2026-10-12 14:59:33
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-12 16:27:06
 * @FilePath: /frasergen-weixin-web/src/pages/Payment_transfer/payment_transfer.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {useState} from 'react'
import {observer} from 'mobx-react-lite'
import { Card,InfiniteScroll } from 'antd-mobile'
import { FileOutline } from 'antd-mobile-icons'
import { Input,Affix } from 'antd';

import {useStore} from '@/store'


const { Search } = Input;
const STATUS_MAP = { 0: '待审批', 2: '已拒绝', 3: '已同意' }


function PaymentTransfer(){

  const [data, setData] = useState([])
  const {PaymentTransferStore} = useStore()


  const [hasMore, setHasMore] = useState(true)
  async function loadMore() {
    PaymentTransferStore.setpage(PaymentTransferStore.page + 1)
    const res = await PaymentTransferStore.getAllPaymentTransfer('')
    setData(val => [...val, ...res])
    setHasMore(res.length > 0)
  }

  const onSearch = async (value)=>{
    if(value === ""){
      setHasMore(true)
      PaymentTransferStore.setpage(0)
      setData([])
    }
    else{
      setHasMore(false)
      PaymentTransferStore.setpage(1)
      const res = await PaymentTransferStore.getAllPaymentTransfer(value)
      setData([...res])
    }
    
    
  }
// {label: '待审批', value: 0}, {label: '已同意', value: 3},{label: '已拒绝', value: 2}
  return (
    <div>
      <div className='search-top'>
        <Affix offsetTop={70}>
          <Search size="large" placeholder="请输入搜索内容" allowClear enterButton onSearch={onSearch} />
        </Affix>
      </div>
      <div>
      {
      data.map((item,index)=>{
        return (
            
          <Card title={
            (<>
              <div className='title-main'>
                <div className='title-1'>
                  <div><FileOutline fontSize={24} color='var(--adm-color-primary)'/>
                  <span>基本信息</span></div>
                </div>
              </div>
            </>)
          } background='gray' key={index} >
            <div className='lefttitle'><span className='righttitle'>状态: </span><span className="content">{STATUS_MAP[item.status] ?? item.status}</span></div>
            <div className="lefttitle"><span className='righttitle'>转款金额: </span><span className="content">{item.amount}</span></div>
            <div className="lefttitle"><span className='righttitle'>转出合同: </span><span className="content">{item.from_contract_no}</span></div>
            <div className="lefttitle"><span className='righttitle'>转入合同: </span><span className="content">{item.to_contract_no}</span></div>
            <div className="lefttitle"><span className='righttitle'>提交人: </span><span className="content">{item.submit}</span></div>
            <div className="lefttitle"><span className='righttitle'>审核人: </span><span className="content">{item.approval_user}</span></div>
            <div className="lefttitle"><span className='righttitle'>创建时间: </span><span className="content">{item.created_at}</span></div>
            <div className="lefttitle"><span className='righttitle'>备注: </span><span className="content">{item.desc}</span></div>
          
          </Card>
        )
      })
      }
      </div>
      <div><InfiniteScroll loadMore={loadMore} hasMore={hasMore} /></div>
    </div>
  )
}

export default observer(PaymentTransfer);